// (c) chaehongee. Confidential and proprietary.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enLanding from './locales/en/landing.json'
import enChat from './locales/en/chat.json'
import enCanvas from './locales/en/canvas.json'
import enDashboard from './locales/en/dashboard.json'
import enBilling from './locales/en/billing.json'
import enErrors from './locales/en/errors.json'
import enPricing from './locales/en/pricing.json'
import enMarketing from './locales/en/marketing.json'

import koCommon from './locales/ko/common.json'
import koAuth from './locales/ko/auth.json'
import koLanding from './locales/ko/landing.json'
import koChat from './locales/ko/chat.json'
import koCanvas from './locales/ko/canvas.json'
import koDashboard from './locales/ko/dashboard.json'
import koBilling from './locales/ko/billing.json'
import koErrors from './locales/ko/errors.json'
import koPricing from './locales/ko/pricing.json'
import koMarketing from './locales/ko/marketing.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        landing: enLanding,
        chat: enChat,
        canvas: enCanvas,
        dashboard: enDashboard,
        billing: enBilling,
        errors: enErrors,
        pricing: enPricing,
        marketing: enMarketing,
      },
      ko: {
        common: koCommon,
        auth: koAuth,
        landing: koLanding,
        chat: koChat,
        canvas: koCanvas,
        dashboard: koDashboard,
        billing: koBilling,
        errors: koErrors,
        pricing: koPricing,
        marketing: koMarketing,
      },
    },
    supportedLngs: ['en', 'ko'],
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: ['common', 'auth', 'landing', 'chat', 'canvas', 'dashboard', 'billing', 'errors', 'pricing', 'marketing'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'knoll_locale',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng)
})

export default i18n
